<template>
  <!-- // 续约结果登记表单 -->
  <div>
    <el-form
      ref="form"
      :rules="rules"
      label-width="120px"
      :model="form"
      :hide-required-asterisk="false"
    >
      <el-form-item label="项目名称:" prop="xmbh">
        <el-select
          ref="xmbh"
          v-model="form.xmbh"
          @change="handleChangeXmbh"
          placeholder="全部"
          clearable
          filterable
          size="small"
          class="filter-item"
          style="width: 100%"
          :disabled="disabled"
        >
          <el-option
            v-for="item in zxlc.xmList"
            :key="item.xmbh"
            :label="item.xmjc"
            :value="item.xmbh"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="续约结果:" prop="xmjg">
        <el-radio-group
          size="small"
          v-model="form.xmjg"
          @change="handleChangeXmjg"
        >
          <el-radio label="1">续约成功</el-radio>
          <el-radio label="3">续约不成功</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="form.xmjg == 1">
        <el-form-item label="续约类型:" prop="xylx">
          <el-radio-group
            size="small"
            v-model="form.xylx"
            @change="handleChangeXylx"
          >
            <el-radio label="1">按DS模式续约</el-radio>
            <el-radio label="2">降级续约</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="续约模式:" prop="xyms" v-if="form.xylx == 2">
          <el-select
            ref="xmlx"
            v-model="form.xyms"
            placeholder="请选择续约模式"
            class="filter-item"
            style="width: 100%"
            filterable
            default-first-option
          >
            <el-option
              v-for="item in zxlc.xymsList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="续约年限:" prop="xynx">
          <el-input-number
            v-model="form.xynx"
            label="描述文字"
            :min="0"
            :precision="2"
          ></el-input-number
          >（年）
        </el-form-item>
        <el-form-item label="续约月单价:" prop="xyydj">
          <el-input-number
            v-model="form.xyydj"
            label="描述文字"
            :precision="2"
            :min="0"
            :max="1000000000"
          ></el-input-number
          >（万元）
        </el-form-item>
      </div>

      <el-form-item label="原因:" prop="yy" v-else>
        <el-input
          show-word-limit
          placeholder="续约不成功的原因"
          maxlength="200"
          :rows="3"
          type="textarea"
          v-model="form.yy"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getXmxydj, saveXmxydj } from "@/api/zxlc.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";

export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "user", "zxlc"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      form: {
        id: null,
        xmbh: null,
        htid: null,
        xmjg: "1",
        xylx: "1",
        xyms: null,
        xynx: null,
        xyydj: null,
        yy: null,
        id: null,
      },
      rules: {
        xmbh: [{ required: true, message: "项目不能为空", trigger: "change" }],
        xmjg: [
          { required: true, message: "续约结果不能为空", trigger: "change" },
        ],
        xylx: [
          { required: true, message: "续约类型不能为空", trigger: "change" },
        ],
        yy: [{ required: true, message: "原因不能为空", trigger: "change" }],
        xyydj: [
          { required: true, message: "续约月单价不能为空", trigger: "change" },
        ],
        xynx: [
          { required: true, message: "续约年限不能为空", trigger: "change" },
        ],
        xyms: [
          { required: true, message: "续约模式不能为空", trigger: "change" },
        ],
        ygbh: [
          { required: true, message: "课题成员不能为空", trigger: "change" },
        ],
      },
      disabled: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.$store.dispatch("zxlc/fetchXymsListAction");

    if (this.mxParams?.xmbh) {
      this.disabled = true;
      this.form.xmbh = this.mxParams.xmbh;
      this.form.htid = this.mxParams.htid;
      this.$store.dispatch("zxlc/fetchXmxxListAction", {
        range: 1,
        bmbh: null,
        xmzt: "1",
      });
    } else {
      this.$store.dispatch("zxlc/fetchXmxxListAction", {
        range: 1,
        bmbh: null,
      });
    }
  },
  mounted() {},

  methods: {
    saveForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.xmjg == 1) {
            this.form.yy = null;
            if (this.form.xylx == 1) {
              this.form.xyms = null;
            }
          } else if (this.form.xmjg == 3) {
            this.form.xylx = null;
            this.form.xyms = null;
            this.form.xynx = null;
            this.form.xyydj = null;
          }
          saveXmxydj({ ...this.form }).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.$emit("giveFather");
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    handleChangeXmbh(e) {
      getXmxydj({ xmbh: e }).then((res) => {
        if (res.code == 0) {
          if (res.data) {
            const { xmjg, xylx, xyms } = res.data;
            this.form = {
              ...res.data,
              xmjg: "" + xmjg,
              xylx: "" + xylx,
              xyms: xyms ? "" + xyms : xyms,
              xmbh: e,
            };
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleChangeXmjg(e) {
      if (e == 1) {
        this.form.yy = null;
        this.form.xylx = "1";
      } else {
        this.form.xylx = null;
        this.form.xynx = null;
        this.form.xyydj = null;
        this.form.xyms = null;
      }
    },
    handleChangeXylx(e) {
      if (e == 1) {
        this.form.xyms = null;
      }
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .vue-treeselect__multi-value-item {
  display: block;
  height: 36px;
  line-height: 36px;
}
::v-deep .vue-treeselect__multi-value {
  height: 40px;
}
</style>